import React from 'react'
import { useRouter } from 'next/router'
import { Box, Button, Card, Flex, Text } from 'pcln-design-system'
import { defaultToday, defaultTomorrow } from '@/shared-utils/date-helper'
import analytics from '@/shared-utils/analytics'
import useGeoPosition from '@/hooks/useGeoPosition'
import SleepIcon from './SleepIcon'
import { invokeFetchCurrentCityData } from '../../machines/currentLocationMachine'
import LayoutComponentWrapper from '../LayoutComponentWrapper'

export default function HotelsTonight() {
  const { pathname = '/' } = useRouter()
  const category = pathname === '/hotels' ? 'HOTEL_HOME' : 'PCLN_HOME'
  const { latitude, longitude } = useGeoPosition()
  const relaxListingsCallBack = async () => {
    if (latitude !== null && longitude !== null) {
      try {
        const { lat, lon, itemName } = await invokeFetchCurrentCityData(
          latitude,
          longitude
        )
        window.location.href = `/relax/geo/${itemName}/${lat}/${lon}/from/${defaultToday}/to/${defaultTomorrow}/rooms/1`
      } catch (error) {
        analytics.fireEvent({
          event: 'Error',
          category,
          action: 'Click',
          data: (error as Error).toString()
        })
        window.location.href = '/hotels'
      }
    } else {
      analytics.fireEvent({
        event: 'Error',
        category,
        action: 'Click',
        data: 'Latitude/Longitude data could not be fetched'
      })
    }
  }

  const handleHotelsTonightClick = (event: MouseEvent) => {
    event.preventDefault()

    analytics.fireEvent({
      category,
      action: 'Click',
      label: 'Hotel Tonight'
    })

    relaxListingsCallBack()
  }

  return (
    <LayoutComponentWrapper>
      <Button
        p={3}
        width={1}
        variation="link"
        data-testid="HOMEPAGE_MWEB_TONIGHT_ONLY_SEARCH"
        onClick={handleHotelsTonightClick}
        target="_self"
        size="large"
      >
        <Card
          color="background.lightest"
          boxShadowSize="sm"
          br="2px"
          borderRadius="lg"
        >
          <Flex px={2}>
            <Box pr={2} mt={2}>
              <SleepIcon
                color="#004499"
                height={40}
                translateX={-2}
                translateY={-1}
                viewBoxHeight={20}
                viewBoxWidth={20}
                width={36}
              />
            </Box>
            <Box p={2}>
              <Text
                fontWeight="bold"
                color="black"
                fontSize={2}
                textAlign="left"
              >
                Need a hotel tonight?
              </Text>
              <Text color="text" mt={2} fontSize={0} textAlign="left">
                Find deals near you.
              </Text>
            </Box>
            <Box width="70px" ml="auto" my="auto">
              <Button size="small" width={1}>
                Search
              </Button>
            </Box>
          </Flex>
        </Card>
      </Button>
    </LayoutComponentWrapper>
  )
}
